module.exports = __webpack_public_path__ + "static/media/no-avatar.57a2e849.png";